import React from "react";
import './Home.css';
import goalsImage from '../Assets/goals.jpg';
import objectivesImage from '../Assets/objectives.jpeg';
import volunteersImage from '../Assets/volunteers.jpeg';

function Home() {
    return (
       <div>
          <div className="home-container">
                <div className="overlay">
                    <h1>Welcome to Volunteers Impact Initiative</h1>
                    <p>Making a difference one step at a time</p>
                </div>
          </div>

          {/*About Section*/}
          <div class="about-section">
            <div class="about-content">
              <h2>Our goals</h2>
              <p>
                Volunteers Impact Initiative (VII) is an NGO based in Ghana with the aim to improve the 
                lives of people in less privileged rural communities through better education, health, 
                and support to orphanages. In addition to these core efforts, VII also engages in community 
                outreach programs, youth mentorship, and advocacy for inclusive development. The organization 
                works closely with local leaders and volunteers to ensure that its impact is both meaningful 
                and sustainable.
              </p>
            </div>
            <div class="about-image">
              <img src={goalsImage} alt="goals" className="mission-image" />
            </div>
          </div>


          {/*Objectives Section*/}
          <div class="objectives-section">
            <div class="objectives-content">
              <h2>Our Objectives</h2>
              <div class="objectives-cards">
                <div class="objective-card">
                  <p>Objectives are linked to the sustainable development goals.</p>
                </div>
                <div class="objective-card">
                  <p>Create enriching opportunities for deprived individuals and communities.</p>
                </div>
                <div class="objective-card">
                  <p>Promote access to basic healthcare and education in rural areas through targeted outreach and support programs.</p>
                </div>
              </div>
            </div>
          </div>


          {/* Where Volunteers Can Assist Section */}
          <div class="assist-section">
            <div class="assist-content">
              <h2>Where Volunteers Can Assist</h2>
              <p>
                <ul>
                    <li>Health and Medicals</li>
                    <li>Teaching at rural community schools (Maths, English, ICT)</li>
                    <li>Orphanage support and child care (feeding them, playing with them)</li>
                    <li>Disability centers, helping people with disabilities like autism by teaching and playing with them to bring them joy and happiness.</li>
                </ul>
              </p>
            </div>  
            

            <div class="assist-image">
              <img src={volunteersImage} alt="volunteersimage" className="mission-image" />
            </div>
          </div>
       </div>
    );
}

export default Home;
